import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// Stylesheet
import "./LatestNFTs.css";

// Assets
import seeMoreArrow from "../../../../assets/seeMoreArrow.png";
import NFTCards from "../../../../components/nftCards/NFTCards";
import {useDispatch, useSelector} from "react-redux";
import {nftFeatureKey} from "../../../../store/featureKeys";
import * as nftActions from "../../../../store/actions/nftActions";
function LatestNFTs() {

  let dispatch = useDispatch()
  const nftData = useSelector(state => state[nftFeatureKey])
  useEffect(()=>{
    dispatch(nftActions.fetchNFTCollection("latest"))
  },[])
  return (
    <section className="nft-section">
      <h2 className="space-heading">LATEST NFTs</h2>
      <div className="right-align line-heading margin-bottom">
        <div className="line"></div>
        <Link to="/explore" className="yellow" >
          SEE MORE <img src={seeMoreArrow} alt="See More" />
        </Link>
      </div>
      <NFTCards nfts={nftData.nfts} length="8"/>
    </section>
  );
}

export default LatestNFTs;
